import { literal, number, object } from "superstruct";

export const StoreCreditRewardSchema = object({
    type: literal("store_credit"),
    storeCredit: number(),
});
